var _path, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgInfusiveLogo2(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 42,
    height: 41,
    viewBox: "0 0 42 41",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M36.1561 41H4.87697C2.1861 41 0.00370608 38.8205 3.93108e-05 36.1297V4.89668C-0.00516383 3.59972 0.506334 2.35419 1.42149 1.4353C2.33666 0.516567 3.58011 0 4.87697 0H36.1561C37.4518 0.00178909 38.6936 0.519012 39.6073 1.43774C40.5209 2.3563 41.0317 3.60086 41.0264 4.89668V36.1297C41.0227 38.818 38.8443 40.9964 36.1561 41ZM17.6935 11.4692C17.6919 11.0358 17.5176 10.6208 17.2092 10.3163C16.9008 10.0116 16.4838 9.84234 16.0504 9.84576H9.21489C8.32087 9.84934 7.59803 10.5752 7.59803 11.4692V31.8115C7.59803 32.7055 8.32087 33.4313 9.21489 33.4349H16.0504C16.9455 33.4313 17.6703 32.7066 17.6739 31.8115L17.6935 11.4692ZM33.4678 20.809C33.4678 20.3749 33.2942 19.9589 32.9854 19.6539C32.6767 19.3489 32.2587 19.1802 31.8247 19.1854H24.9892C24.094 19.1891 23.3693 19.9138 23.3657 20.809V31.8115C23.3693 32.7066 24.094 33.4313 24.9892 33.4349H31.8247C32.7187 33.4313 33.4416 32.7055 33.4416 31.8115L33.4678 20.809Z",
    fill: "url(#paint0_linear_2_675)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_2_675",
    x1: 20.5329,
    y1: 0,
    x2: 20.5329,
    y2: 41,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#0052CC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#2684FF"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgInfusiveLogo2);
export default __webpack_public_path__ + "static/media/Infusive-logo (2).621f7fc603817c0511f0af96deddbcd5.svg";
export { ForwardRef as ReactComponent };